import { clsxMerge } from "shared/lib/helpers";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";

interface ChatUserOnlineIndicatorPropsI extends PropsWithClassNameI {
  isOnline: boolean;
}

export const ChatUserOnlineIndicator = ({
  isOnline,
}: ChatUserOnlineIndicatorPropsI) => (
  <span
    className={clsxMerge(
      "absolute bottom-0 right-0 block h-3 w-3 rounded-full border-2 border-white",
      isOnline ? "bg-green-500" : "bg-gray-400"
    )}
  />
);
